import { Fragment } from 'react';
import { Box, IconButton, Skeleton, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useMobile } from 'shared/domains/common-ui';
import { getLabels } from './utils';
import { useComposerData } from '../../ComposerDataProvider';
import { Filters } from '../Filters';
import { Container } from './styled';
export function Header() {
    const { closeDialog, searchQuery, templatesFilter, loading } = useComposerData();
    const { title, description } = getLabels(searchQuery, templatesFilter);
    const isMobile = useMobile();
    return (<Fragment>
      <Container>
        <Box flexDirection="column" gap="sm">
          <Skeleton loading={loading}>
            <Typography $appearance="300" $fontSize="large" $fontWeight="semibold" $lineHeight="neutralized">
              {title}
            </Typography>
          </Skeleton>
          {!isMobile && (<Skeleton loading={loading}>
              <Typography $appearance="200" $fontSize="small" $lineHeight="neutralized">
                {description}
              </Typography>
            </Skeleton>)}
        </Box>
        <IconButton $round appearance="ghost" onClick={closeDialog}>
          <Falcon icon="xmark"/>
        </IconButton>
      </Container>
      {isMobile && <Filters />}
    </Fragment>);
}
